var exports = {
  "Mb": "ProductAnnouncementModalTabContent__662TAb",
  "Q7": "ProductAnnouncementModalTabContent__heading__StG0rR",
  "So": "ProductAnnouncementModalTabContent--accordion__zynwSH",
  "lF": "ProductAnnouncementModalTabContent--expanded__xPas2y",
  "X0": "ProductAnnouncementModalTabContent__heading-label__vkpCh6",
  "FZ": "ProductAnnouncementModalTabContent__heading-title__2vYI8U",
  "lL": "ProductAnnouncementModalTabContent__content__3vh23y",
  "nE": "ProductAnnouncementModalTabContent__content-dropdown__csTaTP",
  "xe": "ProductAnnouncementModalTabContent__content-ctas__tmiDTv",
};

module.exports = exports;
